
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[slug]/[productSlug]",
      function () {
        return require("private-next-pages/store/[slug]/[productSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[slug]/[productSlug]"])
      });
    }
  